import {DataLink, WidgetType} from "@dv5/domain"
import {FC} from "react"
import {StickyNote} from "./sticky-note/StickyNote"
import {TextWidget} from "./text-widget/TextWidget"
import {ShapeWidget} from "./shape/ShapeWidget"
import {ReactionWidget} from "./reaction/ReactionWidget"
import {MarkdownWidget} from "./markdown-widget/MarkdownWidget"
import {DiagramWidget} from "./diagram/DiagramWidget"
import {TableWidget} from "./table-widget/TableWidget"
import {DocumentWidget} from './document-widget/DocumentWidget'
import {TaskWidget} from './task-widget/TaskWidget'
import {OnNavigateToDocument, OnNavigateToTask, OnStopEditing, WidgetProps} from "../model/WidgetProps"
import {messagesService} from "@dv5/api"

interface Props extends Omit<WidgetProps, 'onDeleteDataLink'> {
    onStopEditing: OnStopEditing
    onNavigateToDocument: OnNavigateToDocument
    onNavigateToTask: OnNavigateToTask
}

interface RemoveDataLink {
    canvasId: string
    dataLinkId: string
    widgetId: string
}

export const WidgetComponent: FC<Props> = ({
                                               canvasId,
                                               widget,
                                               selected,
                                               settings,
                                               editingWidgetId,
                                               onStartDrag,
                                               onStartResize,
                                               onContextMenu,
                                               dragState,
                                               onStartLinkCreation,
                                               onCompleteLinkCreation,
                                               onNavigate,
                                               onStopEditing,
                                               onNavigateToDocument,
                                               onNavigateToTask,
                                           }) => {
    const deleteDataLink = (dataLink: DataLink) => {
        messagesService.send<RemoveDataLink>('canvas.remove-data-link', {
            canvasId: canvasId,
            dataLinkId: dataLink.id,
            widgetId: widget.id
        })
    }

    const commonProps = {
        canvasId,
        widget,
        selected,
        settings,
        editingWidgetId,
        onStartDrag,
        onStartResize,
        onContextMenu,
        dragState,
        onStartLinkCreation,
        onCompleteLinkCreation,
        onNavigate,
        onDeleteDataLink: deleteDataLink,
    }

    switch (widget.type) {
        case WidgetType.STICKY_NOTE:
            return <StickyNote {...commonProps} onStopEditing={onStopEditing} />
        case WidgetType.TEXT_WIDGET:
            return <TextWidget {...commonProps} onStopEditing={onStopEditing} />
        case WidgetType.SHAPE:
            return <ShapeWidget {...commonProps} onStopEditing={onStopEditing} />
        case WidgetType.REACTION:
            return <ReactionWidget {...commonProps} onStopEditing={onStopEditing} />
        case WidgetType.MARKDOWN:
            return <MarkdownWidget {...commonProps} onStopEditing={onStopEditing} />
        case WidgetType.DIAGRAM:
            return <DiagramWidget {...commonProps} onStopEditing={onStopEditing} />
        case WidgetType.TABLE:
            return <TableWidget {...commonProps} onStopEditing={onStopEditing} />
        case WidgetType.DOCUMENT:
            return <DocumentWidget {...commonProps} onNavigateToDocument={onNavigateToDocument} />
        case WidgetType.TASK:
            return <TaskWidget {...commonProps} onNavigateToTask={onNavigateToTask} />
        default:
            console.error("Unknown widget type")
            return null
    }
}
